module.exports = __webpack_public_path__ + "eot/OpenSans-CondLight-webfont.344c34.eot";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/assets/fonts/OpenSans-CondLight-webfont.eot
 ** module id = 317
 ** module chunks = 12
 **/